import { render, staticRenderFns } from "./RatesVolumeDetails.vue?vue&type=template&id=bc82fd96&scoped=true&"
import script from "./RatesVolumeDetails.vue?vue&type=script&lang=js&"
export * from "./RatesVolumeDetails.vue?vue&type=script&lang=js&"
import style0 from "./RatesVolumeDetails.vue?vue&type=style&index=0&id=bc82fd96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc82fd96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc82fd96')) {
      api.createRecord('bc82fd96', component.options)
    } else {
      api.reload('bc82fd96', component.options)
    }
    module.hot.accept("./RatesVolumeDetails.vue?vue&type=template&id=bc82fd96&scoped=true&", function () {
      api.rerender('bc82fd96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/RatesVolumeDetails.vue"
export default component.exports